export default __webpack_public_path__ + "static/media/avarta-suit.24c5fa7d.png";